import { render, staticRenderFns } from "./SaveBuilding.vue?vue&type=template&id=08f6896c&scoped=true"
import script from "./SaveBuilding.vue?vue&type=script&lang=js"
export * from "./SaveBuilding.vue?vue&type=script&lang=js"
import style0 from "./SaveBuilding.vue?vue&type=style&index=0&id=08f6896c&prod&scoped=true&lang=css"
import style1 from "./SaveBuilding.vue?vue&type=style&index=1&id=08f6896c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08f6896c",
  null
  
)

export default component.exports